import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const handleMainSiteClick = () => {
    window.open('https://kaspreadsheet.com/', '_blank', 'noopener,nofollow');
  };

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[650px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20toned%20fashion%20inspiration%20moodboard%20with%20fabric%20swatches%20product%20cards%20and%20dried%20flowers%20arranged%20on%20a%20light%20oak%20desk%2C%20soft%20morning%20sunlight%20streaming%20through%20linen%20curtains%2C%20editorial%20lifestyle%20photography%2C%20earthy%20terracotta%20sage%20green%20and%20cream%20palette%2C%20creative%20studio%20atmosphere%2C%20no%20people%20visible&width=1800&height=1200&seq=hero-bg-v5-unique&orientation=landscape"
          alt="CSSBuy Spreadsheet lifestyle background"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="max-w-4xl">
          <div className="inline-block px-4 py-1.5 bg-accent-500/90 text-background-50 rounded-full text-xs font-semibold tracking-wider mb-6">
            GUIA COMPLETO 2026
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
            CSSBuy{' '}
            <span className="font-light italic">Spreadsheet</span>
            <br />
            <span className="text-2xl md:text-3xl lg:text-4xl font-body font-normal opacity-90">
              O Guia Definitivo para Comprar da China
            </span>
          </h1>

          <p className="text-base md:text-lg text-background-50/80 max-w-xl mb-8 leading-relaxed">
            Aprenda a usar o CSSBuy Spreadsheet para organizar suas compras internacionais.
            Compare preços, avalie lojas e importe produtos da China com segurança e economia.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50 text-primary-600 rounded-full text-base font-semibold hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap"
            >
              CSSBuy Spreadsheet
              <i className="ri-external-link-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border-2 border-background-50/60 text-background-50 rounded-full text-base font-semibold hover:bg-background-50/10 transition-all cursor-pointer whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}